module.exports = __webpack_public_path__ + "img/CLIK_PROF_LOGO.f48f583f.png";